import { ContextService } from '../../services/context_service';
import { Font, Image, Page, Text, View } from '@react-pdf/renderer';
import { getReportConfig } from './helper/getReportConfigs';
import { lazyInject } from '../../services/inversify';
import * as Moment from 'moment';
import * as React from 'react';
import { WpdfText } from '../datenauswertung/pdf/WpdfText.';
import { WpdfView } from '../datenauswertung/pdf/WpdfView';

interface DatenauswertungReportTextProps extends React.ClassAttributes<any> {
    isPdf?: boolean;
}

interface DatenauswertungReportTextState {
    data: string;
    pdfData: any;
}

export class DatenauswertungReportText extends React.Component<DatenauswertungReportTextProps, DatenauswertungReportTextState> {

    constructor(props: any) {
        super(props);
        this.state = {
            data: null,
            pdfData: null
        };
        this.init();
    }

    @lazyInject(ContextService) private contextService: ContextService;

    private data: string;
    private styles: any;

    init(): void {
        const contextReport: any = this.contextService.get('report_config') || {};
        const data: any = contextReport.useContext && Object.keys(contextReport.config || {}).length
            ? getReportConfig([{ konfiguration: contextReport.config }]) || {} : {};
        this.setStyles();
        this.data = data.text || null;
    }

    render(): JSX.Element | JSX.Element[] {
        if (!this.data) {
            return null;
        }

        if (this.props.isPdf) {
            return this.renderPdf();
        }

        return this.renderText();
    }

    renderHeader(): JSX.Element {
        const header = require('../../img/logo_mittel2.png');
        const { styles } = this;

        return (
            <View style={styles.header} fixed>
                <Text style={styles.headerText}>E-Tool</Text>
                <Image src={header} style={styles.headerImage} />
            </View>
        );
    }

    renderFooter(): JSX.Element {
        const { styles } = this;

        return (
            <View style={styles.footer} fixed>
                <Text>{Moment().format('DD.MM.YYYY')}</Text>
                <View style={styles.footerPages}>
                    <Text
                        render={({ pageNumber, totalPages }) => {
                            if (totalPages > 1) {
                                return `${pageNumber}/${totalPages}`;
                            }
                        }}
                        fixed
                    />
                </View>
            </View>
        );
    }

    renderPdf(): JSX.Element {
        Font.register({ family: 'Calibri-Bold', src: require('../../font/calibri_regular.ttf') });

        return (
            <Page size='A4' orientation='portrait' style={this.styles.page}>
                {this.renderHeader()}
                {this.renderText()}
                {this.renderFooter()}
            </Page>
        );
    }

    setStyles(): void {
        this.styles = {
            header: {
                fontSize: '18pt',
                fontFamily: 'Helvetica-Bold',
                color: '#555',
                width: '100%',
                height: 60,
                top: 0,
                left: 0,
                padding: 0,
                position: 'relative',
                display: 'block'
            },
            headerImage: {
                width: 241,
                height: 40,
                top: 0,
                right: 0,
                position: 'absolute',
                display: 'inline-block'
            },
            headerText: {
            },
            footer: {
                fontSize: '8pt',
                right: 40,
                bottom: 15,
                left: 40,
                width: '100%',
                height: 'auto',
                padding: 0,
                position: 'absolute',
                display: 'block',
                boxSizing: 'border-box'
            },
            footerPages: {
                right: 0,
                position: 'absolute'
            },
            page: {
                fontFamily: 'Helvetica',
                fontSize: '9pt',
                padding: 40,
                paddingTop: 20,
                paddingBottom: 25
            },
            text: {
                padding: 1
            }
        };
    }

    renderText(): JSX.Element {
        const { isPdf } = this.props;
        const { styles } = this;

        return (
            <WpdfView pdf={isPdf}>
                <WpdfText style={styles.text} pdf={isPdf}>
                    {this.data}
                </WpdfText>
            </WpdfView>
        );
    }
}
